import { render, staticRenderFns } from "./deliveryTabKfw.vue?vue&type=template&id=4c12daf6&scoped=true"
import script from "./deliveryTabKfw.vue?vue&type=script&lang=js"
export * from "./deliveryTabKfw.vue?vue&type=script&lang=js"
import style0 from "./deliveryTabKfw.vue?vue&type=style&index=0&id=4c12daf6&lang=scss"
import style1 from "./deliveryTabKfw.vue?vue&type=style&index=1&id=4c12daf6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c12daf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c12daf6')) {
      api.createRecord('4c12daf6', component.options)
    } else {
      api.reload('4c12daf6', component.options)
    }
    module.hot.accept("./deliveryTabKfw.vue?vue&type=template&id=4c12daf6&scoped=true", function () {
      api.rerender('4c12daf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialog/deliveryTab/deliveryTabKfw.vue"
export default component.exports